// WP-07 — D-F1 string-catalogue discipline (mirror of the API's I18nService).
import { en, type CatalogueKey } from "./en.catalogue";

const catalogues: Record<string, Record<CatalogueKey, string>> = { en };
const DEFAULT_LOCALE = "en";

/** Translate a catalogue key; `{param}` placeholders filled from `params`. */
export function t(
  key: CatalogueKey,
  params?: Record<string, string>,
  locale: string = DEFAULT_LOCALE,
): string {
  const catalogue = catalogues[locale] ?? catalogues[DEFAULT_LOCALE];
  // Fallback chain: requested locale -> en -> the key itself (visible miss).
  const template = catalogue?.[key] ?? en[key] ?? key;
  if (!params) return template;
  return template.replace(
    /\{(\w+)\}/g,
    (match, name: string) => params[name] ?? match,
  );
}
